<template>
   <el-form ref="form" :rules="rules" :model="currForm" label-width="80px" label-position="left">
      <el-form-item label="名称" prop="name">
         <el-input :disabled="!edit" style="width: 300px" placeholder="最多20个字" v-model="currForm.name"></el-input>
         <span v-if="currForm.id">当前装配人数：{{ currForm.countUsed }}</span>
      </el-form-item>
      <el-form-item label="贴纸" prop="content">
         <UploadDragImg v-if="edit" :disabled="edit" tips="（尺寸：155*155，jpg、png）" :imgUrl.sync="currForm.content" />
         <img v-else width="360" height="180" :src="currForm.content" alt="" />
      </el-form-item>
      <el-form-item label="展示排序" prop="sort">
         <el-input-number :min="0" :disabled="!edit" v-model="currForm.sort"></el-input-number>
         <div>数字越大越靠前</div>
      </el-form-item>
      <el-form-item label="拥有学生">
         <SelectStudent :disabled="edit" ref="SelectStudentRef" :selectVal.sync="currForm.useType"
            :privileges="currForm.privilegeRole">
         </SelectStudent>
      </el-form-item>
      <el-form-item label="角标图片">
         <SUpload
            v-model="currForm.superscript"
            accept="image/*"
            type="drag"
            :size="50"
            :disabled="!edit"
            :show-file-list="false"
         />
         <div class="tips">尺寸建议40*40，最大50KB，优先SVG其次png</div>
      </el-form-item>
   </el-form>
</template>

<script>
import UploadDragImg from "../../../../../components/common/UploadDragImg.vue";
import UploadImg from "../../../../../components/common/UploadImg.vue";
import SelectStudent from "./SelectStudent.vue";
export default {
   props: {
      form: {
         type: Object,
         default: () => ({}),
      },
      edit: {
         type: Boolean,
         default: true,
      },
   },
   components: { UploadDragImg, UploadImg, SelectStudent },
   data() {
      return {
         userId: "",
         currForm: {
            useType: 0,
         },
         rules: {
            name: [{ required: true, message: "请输入名称", trigger: "blur" }],
            content: [{ required: true, message: "请上传图片", trigger: "change" }],
            sort: [
               {
                  required: true,
                  type: "number",
                  message: "请输入排序",
                  trigger: "change",
               },
            ],
         },
      };
   },
   watch: {
      form: {
         handler(newValue, oldVal) {
            this.currForm = JSON.parse(JSON.stringify(newValue));
         },
         deep: true,
         immediate: true,
      },
   },
   methods: {
      submit(release = false) {
         this.$refs.form.validate(async (valid) => {
            if (valid) {
               const uids = this.$refs.SelectStudentRef.selectItemList.map(
                  (item) => item.uid
               );
               const params = {
                  name: this.currForm.name,
                  useType: this.currForm.useType,
                  sort: this.currForm.sort,
                  content: this.currForm.content,
                  businessType: this.currForm.businessType,
                  status: this.currForm.status,
                  superscript: this.currForm.superscript,
               };
               if (this.currForm.useType === 1) {
                  params.uids = uids;
               } else if (this.currForm.useType === 2) {
                  params.privilegeRole = this.$refs.SelectStudentRef.selectPrivileges.join(',');
               }
               if (this.currForm.id) {
                  params.id = this.currForm.id;
               }
               const res = await this.$http({
                  url:
                     this.$util.domain +
                     "/adminapi/v1/personalizedComponents/addOrEdit",
                  method: "post",
                  body: JSON.stringify(params),
               });
               if (res.data.error === 10000) {
                  if (release) {
                     const response = await this.$http({
                        method: "get",
                        url:
                           this.$util.domain +
                           "/adminapi/v1/personalizedComponents/change",
                        params: {
                           id: res.data.data,
                           status: 3,
                        },
                     });
                     if (response.data.error === 10000) {
                        this.$message.success("操作成功");
                        this.$router.push("/yunying/userDiyPage");
                     } else {
                        this.$message.error(response.data.message || "操作失败");
                     }
                  } else {
                     this.$message.success("操作成功");
                     this.$router.push("/yunying/userDiyPage");
                  }
               } else {
                  this.$message.error(res.data.message || "操作失败");
               }
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
   },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// PosterSticker.vue?4cb6103d